import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {
  reactive,
  watch,
  computed,
  ref,
  nextTick,
} from 'vue';
import { getNameByMode } from '~utils/stringHelpers';
// eslint-disable-next-line import/no-cycle
import { useAuthStore } from '@/store/auth/authModule';
import { useMainStore } from '@/store';
import {
  storeToRefs,
  getActivePinia,
  Pinia,
  Store,
} from 'pinia';
import { useSocket } from '@/utils/socket';
// eslint-disable-next-line import/no-cycle
import router from '@/router';

interface ExtendedPinia extends Pinia {
  _s: Map<string, Store>;
}
type MenuLink = {
  id: number,
  link: string,
  text: string,
  note?: string,
};


export default /*@__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props) {

const { connected, emitPatientCreated, on } = useSocket();

const $ResetPinia = (): void => {
  const pinia = getActivePinia() as ExtendedPinia;

  if (!pinia) {
    throw new Error('There is no stores');
  }

  pinia._s.forEach((store) => {
    store.$reset();
  });
};
const data = reactive({
  seamless: false,
  src: '',
  text: '',
});
const reportDialog = ref();
const store = useAuthStore();
const { userName } = storeToRefs(store);

const visibleUserName = computed(() => {
  if (userName) {
    return getNameByMode(userName.value, 'lastname');
  }
  return '';
});
const avatarInitials = computed(() => {
  if (userName) {
    return getNameByMode(userName.value, 'initials');
  }
  return '';
});
const goToMain = () => {
  router.push({ name: 'HealthPageFull' });
};

const logout = () => {
  $ResetPinia();
  useAuthStore().logout();
};

const menu: MenuLink[] = [
  {
    id: 1,
    link: '/dashboard',
    text: 'Главная',
  },
  {
    id: 2,
    link: '/gu-like',
    text: 'GU-like',
  },
];


return (_ctx: any,_cache: any) => {
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_header = _resolveComponent("q-header")!

  return (_unref(store).isAuth)
    ? (_openBlock(), _createBlock(_component_q_header, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(_component_q_toolbar, null, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "header__username cursor-pointer",
                onClick: goToMain
              }, [
                _createVNode(_component_q_avatar, {
                  size: "32px",
                  color: "white",
                  "text-color": "dark",
                  class: "q-mr-xs"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(avatarInitials.value), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", null, _toDisplayString(visibleUserName.value), 1)
              ]),
              _createVNode(_component_q_space),
              _createVNode(_component_q_btn, {
                size: "md",
                flat: "",
                icon: "logout",
                color: "white",
                "text-color": "white",
                label: "",
                onClick: logout
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})